/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from '@essex/styled-components'

export const icons = {
	add: { iconName: 'Add' },
	delete: { iconName: 'Delete' },
}

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`

export const Tables = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`
